<template>
  <b-modal
    id="consolidateModal"
    size="md"
    header-bg-variant="lisaweb"
    body-class="pt-3"
    footer-class="py-2 px-3"
    no-close-on-backdrop
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <span>Consolidamento {{ entity }}</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        <base-icon name="close" width="14" height="14" />
      </button>
    </template>
    <div>
      L'operazione interessa
      <strong>{{ total }} {{ entity }}</strong> che rispettano i filtri attivi.
    </div>
    <!--
      Footer custom a tre pulsanti: non si usa showConfirm perché msgBoxConfirm ne ha solo due
      e instrada nel ramo "no" anche la chiusura con Esc/backdrop, quindi la rimozione del
      consolidamento sarebbe partita annullando.
    -->
    <template #modal-footer="{ cancel }">
      <b-form-group class="mb-0">
        <div class="d-flex">
          <b-button
            @click="cancel()"
            class="btn--transparent mr-2"
            size="sm"
            variant="outline-secondary"
            >Annulla
          </b-button>
          <b-button
            @click="onConsolidate('N', cancel)"
            class="mr-2"
            size="sm"
            variant="-destroy"
            title="Rimuove il consolidamento da quanto rispetta i filtri attivi"
            >Rimuovi consolidamento
          </b-button>
          <b-button
            @click="onConsolidate('Y', cancel)"
            size="sm"
            variant="lisaweb"
            >Consolida
          </b-button>
        </div>
      </b-form-group>
    </template>
  </b-modal>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";

/*
 * Modale del consolidamento massivo, condivisa fra la schermata dei titoli e quella delle
 * quietanze: le due pagine consolidano lo stesso flag (quello del titolo) ma passano da
 * endpoint diversi, quindi la chiamata resta al parent che ascolta "consolidate".
 */
export default {
  name: "ConsolidateModal",
  components: { BaseIcon },
  props: {
    /* Quante righe rispettano il filtro corrente della griglia */
    total: {
      type: Number,
      default: 0,
    },
    /* Plurale del soggetto: "titoli" oppure "quietanze" */
    entity: {
      type: String,
      required: true,
    },
  },
  methods: {
    onConsolidate(value, cancel) {
      cancel();
      this.$emit("consolidate", value);
    },
  },
};
</script>
